export const cloudinaryConfig = {
	cloudName: 'dm0hlajo4',
	uploadPreset: 'dientudl',
	baseUrl: 'https://api.cloudinary.com/v1_1/dm0hlajo4/auto/upload',
};
